/**
 * #4386 (AUTHHANG): the contract between the server's session-read deadline
 * and the client's sign-in-again banner. The server answers 503 with this
 * `code` when better-auth gives no answer in time (src/server/auth.ts,
 * runAuthHandler); the client shows the banner on it (src/client/lib/session-check.ts).
 */
export const SESSION_TIMEOUT_CODE = "SESSION_TIMEOUT";
export const SESSION_TIMEOUT_MESSAGE = "Couldn't check your sign-in. Please sign in again.";
